export default __webpack_public_path__ + "static/media/gallery_11.02864b81.jpg";